import React from 'react';
import { ButtonV2, DialogV2, Flex, IconV2, TextV2 } from '@withjoy/joykit';
import { CheckOutline } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import PoweredByStripe from '@assets/PoweredbyStripe.png';
import { useCreditCardSetupTelemetry } from '../CreditCardSetUp.telemetry';
import { useMount } from '@shared/utils/hooks/useMount';
import { useManagedSearchParam } from '@shared/hooks/useManagedSearchParam';

interface ReadyToUseProps {
  onClose: () => void;
}

export const ReadyToUse: React.FC<ReadyToUseProps> = ({ onClose }) => {
  const { t2 } = useTranslation('sharedRegistry');
  const { stripeApprovedTitle, next, successJoyWalletDescription } = t2('creditCardSetUpDialog');
  const [, setAddGift] = useManagedSearchParam('addGift');

  const telemetry = useCreditCardSetupTelemetry();
  useMount(() => {
    telemetry.creditCardSetupDialog.enter('success');
  });
  return (
    <>
      <DialogV2.Body>
        <Flex
          marginX="auto"
          paddingX={7}
          maxWidth="540px"
          width="100%"
          paddingTop={10}
          flexDirection="column"
          alignItems="center"
        >
          <IconV2
            size="xxl"
            color="mono14"
          >
            <CheckOutline />
          </IconV2>
          <TextV2
            marginY={2}
            textAlign="center"
            typographyVariant="display2"
            color="mono14"
          >
            {stripeApprovedTitle}
          </TextV2>
          <TextV2
            textAlign="center"
            typographyVariant="body3"
            color="mono12"
          >
            {successJoyWalletDescription}
          </TextV2>
          <ButtonV2
            onClick={() => {
              telemetry.createCashFundButtonClicked();
              onClose();
              return setAddGift('true');
            }}
            marginTop={10}
            shape="rounded"
            intent="neutral"
          >
            {next}
          </ButtonV2>
        </Flex>
      </DialogV2.Body>
      <DialogV2.Footer justifyContent="center">
        <Flex
          justifyContent="center"
          alignItems="center"
        >
          <img
            src={PoweredByStripe}
            title="Stripe"
            alt="stripe"
          />
        </Flex>
      </DialogV2.Footer>
    </>
  );
};
